import * as React from 'react'
import PropTypes from 'prop-types'

import {
  DASHBOARD_URL,
  INBOX_URL,
  ARTIST_PROFILES_URL,
  HELP_URL,
} from '../../../models/Controlpanel'

import { DesktopMenu, RequestsUnreadCountWrapper, ButtonInnerContent } from './style'

import HeaderMenuItemUserDesktop from '../../header-menu-item-user-desktop'
import HeaderMenuList from '../../../ui/header-menu-list'
import HeaderMenuItem from '../../../ui/header-menu-list-item'
import HeaderMenuButton from '../../../ui/header-menu-button'
import GigRequestUnreadCount from '../../gig-request-unread-count'

const EvenplannerDektopMenu = () => (
  <DesktopMenu>
    <HeaderMenuList>
      <HeaderMenuItem>
        <HeaderMenuButton
          to={DASHBOARD_URL}
          title="Gå til kontrollpanel"
          aria-label="Gå til kontrollpanel"
        >
          Kontrollpanel
        </HeaderMenuButton>
      </HeaderMenuItem>
      <HeaderMenuItem>
        <HeaderMenuButton
          to={INBOX_URL}
          title="Gå til forespørsler"
          aria-label="Gå til forespørsler"
        >
          <ButtonInnerContent>
            Forespørsler
            <RequestsUnreadCountWrapper>
              <GigRequestUnreadCount forArtist />
            </RequestsUnreadCountWrapper>
          </ButtonInnerContent>
        </HeaderMenuButton>
      </HeaderMenuItem>
      <HeaderMenuItem>
        <HeaderMenuButton
          to={ARTIST_PROFILES_URL}
          title="Gå til artist-profiler"
          aria-label="Gå til artist-profiler"
        >
          Artist-profiler
        </HeaderMenuButton>
      </HeaderMenuItem>
      <HeaderMenuItem>
        <HeaderMenuButton to={HELP_URL} title="Gå til hjelp" aria-label="Gå til hjelp">
          Hjelp
        </HeaderMenuButton>
      </HeaderMenuItem>
    </HeaderMenuList>
    <HeaderMenuList>
      <HeaderMenuItemUserDesktop showControlpanelMenu />
    </HeaderMenuList>
  </DesktopMenu>
)

EvenplannerDektopMenu.propTypes = {}
EvenplannerDektopMenu.defaultProps = {}

export default EvenplannerDektopMenu
